export  const questions=[
    {   
        id:'1',
        question:"Do you get fascinated by visual designs and pattern ?",
        val:1 
    },
    {
        id:"2",
        question:"Do you possess an interest in logic building and analytical thinking ?",
        val:1
    },
    {
        id:'3',
        question:" Are you interested in debugging/solving errors?",
        val:1
    }
]

